import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { PageEvent, Sort, MatTableDataSource, MatSort, MatExpansionPanel, MatSnackBar } from '@angular/material';
import { Subscription } from 'rxjs';
import { VolverService } from '../../../providers/volver.service';
import { PersonasService } from '../../../providers/personas.service';
import { ComunicacionService } from '../../../providers/comunicacion.service';
import { ClienteService } from '../../../providers/cliente.service';
import { FormatDatePipe } from '../../../pipes/transforms/format-date.pipe';
import * as moment from 'moment';
import { saveAs } from 'file-saver';
import { ContactoService } from '../../../providers/contacto.service';
import { Contacto, TipoContacto } from '../../../interfaces/contacto';
import { Telefono } from '../../telefono/telefono.component';
import { TipoCliente } from '../../../forms/clientes/tipos-cliente/tipo-cliente/tipo-cliente';
import { TipoClienteService } from '../../../forms/clientes/tipos-cliente/tipo-cliente/tipo-cliente.service';
import { PropuestasService } from '../../../providers/propuestas.service';
import { m } from '@angular/core/src/render3';
@Component({
  selector: 'app-listado-personas',
  templateUrl: './listado-personas.component.html',
  styleUrls: ['./listado-personas.component.scss']
})
export class ListadoPersonasComponent implements OnInit {
  readonly titulo = 'Personas';
  columnas = [
    'id',
    'razonSocial',
    'nombreFantasia',
    'Email',
    'CUIT',
    'Referencia',
    'Curso',
    'Tipo',
    'propuestas',
    'acciones'
 
  ];
  sort: Sort = { active: '', direction: '' };
  page: PageEvent = new PageEvent();
  filtros: any = {
    generico: '',
    razonSocial: '',
    fantasia:'',
    apellido:'',
    provincia:'',
    Referencia: '',
    Tipo: '',
    Contacto: '',
    telefono: '',
    email: '',
    curso:'',
    documento:'',
    formulario: '',
  };
  title = "Contactos";
  descargandolistado: boolean = false;
  cargando: boolean;
  cargandoTiposCliente: boolean;
  tiposCliente: TipoCliente[] = [];
  filtrosLista = [{ Referencia: '', 
    Valor: '',
    busquedaColumna: '',    // Campo de búsqueda específico para este filtro
    columnasFiltradas: [],  // Columnas filtradas para este filtro
    busquedaSelect: '',     // Campo de búsqueda para el select
    opcionesFiltradas: []   // Opciones filtradas para el select
   }];
  columnasPersonalizadas:any = [];
  columnasFiltradas:any = []; // Inicialmente, todas las columnas visibles
  busquedaColumna = '';
  actualizarTablaTimeout: any; // prevenir muchos llamados consecutivos al webserver
  flag_primera_carga: boolean = true; // primera solicitud a traer datos
  cargandoTimeout: any;
  cursos:any;
  PersonasDataSource = new MatTableDataSource();
  getClientesSuscripcion: Subscription;
  clientesCount: number = 0;
  tieneFiltrosOrdenPaginado = false;
  panelConFiltroActivo = false;
  total: number;
  max_progreso: number;
  list_provincias: any = [];
  list_localidades: any = [];
  list_paises: any = [];
  busquedaSelect: string = '';
  opcionesFiltradas: any[] = [];
  filterMode: 'default' | 'home' = 'default';
  estados: any = [];
  @ViewChild(MatSort) matSort: MatSort;
  @Output() onHoraInput = new EventEmitter();
  @Input() filtrosExternos: any = {}; // filtros que se aplican según el lugar donde se muestran las incidencias
  @ViewChild('filtrosPanel') set filtrosPanel(v: MatExpansionPanel) {
    if (typeof v != 'undefined') {
      setTimeout(() => {
        this.checkPageState();
        if (this.panelConFiltroActivo) {
          v.open();
        }
      }, 25);
    }
  };
  contactos: Contacto[] = <Contacto[]>[];
  entidadContactos: any = [];
  constructor(
    private _personasSv: PersonasService,
    private _cmSv: ComunicacionService,
    private volverSv: VolverService,
    private snackBar: MatSnackBar,
    private datePipe: FormatDatePipe,
    private contactoService: ContactoService,
    private tipoClienteSv: TipoClienteService,
    private _propuestasSv: PropuestasService,
  ) { }

  @Input('filtrado') filtrado: boolean = true;

  ngOnInit() {
    this.reiniciarPageState();
    this.traerTiposCliente();
    this.traerCursos();
    this.getColumnas();
    this.getCiudadProviciaPais();
  }

  traerTiposCliente(): void {
    this.tiposCliente = [];
    this.cargandoTiposCliente = true;
    this.tipoClienteSv.getTiposCliente().subscribe(
      respuesta => {
        if (respuesta.estado == 1 && respuesta.data && respuesta.data.tiposCliente) {
          respuesta.data.tiposCliente.forEach(tipoCliente => {
            this.tiposCliente.push(<TipoCliente>{
              id: tipoCliente.id,
              descripcion: tipoCliente.descripcion
            });
          });
        }
      },
      () => {
        this.cargandoTiposCliente = false;
      },
      () => {
        this.cargandoTiposCliente = false;
      }
    );
  }

  traerCursos() {
    this._propuestasSv.getCursos(
      {
        page: null,
        estado_curso: 1
      },
    ).subscribe(
      respuesta => {
        let _cursos = [];
        respuesta.cursos.forEach(element => {
          _cursos.push({
            id: element.id,
            descripcion: element.descripcion,
            cantidad_estados: element.cantidad
          })
        });
        // this.cursosDataSource.data = cursos;
        this.cursos = _cursos;

      },
      (err) => {
        console.log(err, "err");

      }
    )
  }
    // Método para mostrar los filtros por defecto (el que ya tenías)
    showDefaultFilters(event: MouseEvent): void {
      // event.stopPropagation();
      this.filterMode = 'default';
    }
  
    // Método para mostrar el conjunto alternativo de filtros (para el botón home)
    showHomeFilters(event: MouseEvent): void {
      // event.stopPropagation();
      this.filterMode = 'home';
    }
  getColumnas(){
 
    this._personasSv.getColumnas('Entidades').subscribe(
      respuesta => {
        console.log(respuesta.data, "respuesta");
        this.columnasPersonalizadas = respuesta.data;
        this.columnasFiltradas = [...this.columnasPersonalizadas];
      }
    )
  }
  getCiudadProviciaPais(){
    this._personasSv.getCiudadProviciaPais().subscribe(
      respuesta => {
        console.log(respuesta.provincias, "respuesta");
        this.list_provincias = respuesta.provincias;
        console.log(this.list_provincias, "Provincias");
        this.list_localidades = respuesta.localidades;
        console.log(this.list_localidades, "Localidades");
        this.list_paises = respuesta.paises;
      }
    )
  }
  onColumnaChange(filtro: any) {
    console.log('Filtro cambiado', filtro);
    if (filtro.Referencia != 'EntidadProvincia') {
      filtro.Valor = ''; // Reiniciar el valor si cambia a una opción que no es provincia
    }
    if (filtro.Referencia != 'EntidadLocalidad') {
      filtro.Valor = ''; // Reiniciar el valor si cambia a una opción que no es provincia
    }
    if (filtro.Referencia != 'EntidadPais') {
      filtro.Valor = ''; // Reiniciar el valor si cambia a una opción que no es provincia
    }
    if (filtro.Referencia != 'EntidadIdTipoCliente') {
      filtro.Valor = ''; // Reiniciar el valor si cambia a una opción que no es provincia
    }
  }

  
  esSelect(referencia: string): boolean {
    return ['EntidadProvincia', 'EntidadLocalidad', 'EntidadPais', 'EntidadIdTipoCliente'].includes(referencia);
  }
  
  obtenerLista(referencia: string): any[] {
    switch (referencia) {
      case 'EntidadProvincia': return this.list_provincias;
      case 'EntidadLocalidad': return this.list_localidades;
      case 'EntidadPais': return this.list_paises;
      case 'EntidadIdTipoCliente': return this.tiposCliente;
      default: return [];
    }
  }
  
  getIdKey(referencia: string): string {
    switch (referencia) {
      case 'EntidadProvincia': return 'IdProvincia';
      case 'EntidadLocalidad': return 'IdLocalidad';
      case 'EntidadPais': return 'IdPais';
      case 'EntidadIdTipoCliente': return 'id';
      default: return '';
    }
  }
  
  getNombreKey(referencia: string): string {
    switch (referencia) {
      case 'EntidadProvincia': return 'ProvinciaNombre';
      case 'EntidadLocalidad': return 'LocalidadNombre';
      case 'EntidadPais': return 'PaisNombre';
      case 'EntidadIdTipoCliente': return 'descripcion';
      default: return '';
    }
  }

  
  
filtrarOpciones(referencia: string): void {

  const filtro = this.filtrosLista.find(f => f.Referencia === referencia);
  if (filtro.busquedaSelect.trim() === "") {
    filtro.opcionesFiltradas = [...this.obtenerLista(referencia)];  // Si la búsqueda está vacía, restaurar todas las opciones
  } else {
    filtro.opcionesFiltradas = this.obtenerLista(referencia).filter(item => 
      item[this.getNombreKey(referencia)].toLowerCase().includes(filtro.busquedaSelect.toLowerCase())
    );
  }
}

onKeyUp(event: KeyboardEvent, filtro: any) {
  console.log('Key up', event.key, filtro);
  event.stopPropagation(); // Evita que el evento se propague y cierre el select

  filtro.opcionesFiltradas = this.obtenerLista(filtro.Referencia).filter(item =>
    item[this.getNombreKey(filtro.Referencia)].toLowerCase().includes(filtro.busquedaSelect.toLowerCase())
  );
}


onSelectOpenSelect(filtro: any): void {
  // Restaurar todas las opciones al abrir el select, si no hay búsqueda
  if (filtro.busquedaSelect.trim() == "") {
    filtro.opcionesFiltradas = [...this.obtenerLista(filtro.Referencia)];  // Restaurar lista completa
  }
}

  onColumnaSeleccionada(filtro:any): void {
    console.log('Columna seleccionada', filtro);
    this.busquedaColumna = ''; // Limpiar la búsqueda cuando se selecciona una opción
    this.filtrarColumnas(filtro); // Volver a aplicar el filtro con la lista completa
    this.busquedaSelect = ''; // Limpiar la búsqueda del select
    // También debes asegurarte de que se actualicen las opciones filtradas cuando sea necesario
  }

  agregarFiltro() {
    // Agrega un nuevo filtro con su propio campo de búsqueda y las propiedades necesarias
    this.filtrosLista.push({
      Referencia: '',
      Valor: '',
      busquedaColumna: '',
      columnasFiltradas: [...this.columnasPersonalizadas], // Inicia con todas las columnas
      busquedaSelect: '', // Añadir la propiedad de búsqueda para select
      opcionesFiltradas: [...this.obtenerLista('Referencia')], // Inicia con las opciones completas
    });
  }

  eliminarFiltro(index: number) {
    this.filtrosLista.splice(index, 1);
  }

  buscarFiltro(){
    const filtrosConvertidos = this.filtrosLista.map(obj => ({ [obj.Referencia]: obj.Valor }));
    this.cargando = true;
    this._personasSv.filtroPersonalizado(
      {
        page: this.page.pageIndex,
        pageSize: this.page.pageSize
      },
      {
        sort: this.sort.active,
        order: this.sort.direction
      },
      "Entidades",
      filtrosConvertidos
    )
    .subscribe(
        respuesta => {
          console.log(respuesta, "respuesta Filtros");
          this.cargando = false;
          const data = this._cmSv.format(respuesta, false);
          if (data != this._cmSv.SIN_DATA) {
            this.PersonasDataSource.data = data.entidades.map(entidades => {
              // this.traerContactos(entidades.id); // traer sus contactos
              return entidades
            });

            this.max_progreso = data.max_progreso;
            this.total = data.total;
            let i = 0;
            while (10 > i) {
              this.estados[i] = this.colorProgreso(i + 1, 1, 10);
              i++;
            }
          }
        },
        () => {
          this.cargando = false; // ocultar progress bar si se estaba mostrando
        },
        () => {
          this.cargando = false; // ocultar progress bar si se estaba mostrando
        }
      );
  }

  onSelectOpen(filtro: any): void {
    // Restaurar todas las opciones al abrir el select, si no hay búsqueda
    if (filtro.busquedaColumna.trim() === "") {
      filtro.columnasFiltradas = [...this.columnasPersonalizadas];  // Restaurar lista completa
    }
  }

  filtrarColumnas(filtro: any): void {
    console.log('Filtrar columnas', filtro);
    if (filtro.busquedaColumna.trim() == "") {
      console.log('Restaurando todas las opciones');
      filtro.columnasFiltradas = [...this.columnasPersonalizadas]; // Restaurar todas las opciones si la búsqueda está vacía
    } else {
      console.log('Filtrando columnas por búsqueda');
      filtro.columnasFiltradas = this.columnasPersonalizadas.filter(columna => 
        columna.toLowerCase().includes(filtro.busquedaColumna.toLowerCase())
      );
    }
  }

  _limpiarPageState() {
    // filtros
    localStorage.setItem('ver_personas_filtros', null);
    // paginado
    localStorage.setItem('ver_personas_paginado', null);
    // sort
    localStorage.setItem('ver_personas_sort', null);
  }

  recordarPageState() {
    // filtros
    localStorage.setItem('ver_personas_filtros', JSON.stringify(this.filtros));
    // paginado
    localStorage.setItem('ver_personas_paginado', JSON.stringify(this.page));
    // sort
    localStorage.setItem('ver_personas_sort', JSON.stringify(this.sort));
  }

  checkPageState(): boolean {
    this.tieneFiltrosOrdenPaginado = false;
    // checkear si hay almenos un filtro aplicado
    this.panelConFiltroActivo = false;
    for (let propiedad in this.filtros) {
      if (this.filtros[propiedad]) {
        this.tieneFiltrosOrdenPaginado = true;
        this.panelConFiltroActivo = true;
        break;
      }
    }
    // checkear si hay paginado
    if (this.page.pageIndex != 0) {
      this.tieneFiltrosOrdenPaginado = true;
    }
    // checkear si hay ordenamiento
    if (this.sort.active != '' && (this.sort.active != 'fechaModificacion' || this.sort.direction != 'desc')) {
      this.tieneFiltrosOrdenPaginado = true;
    }
    return this.tieneFiltrosOrdenPaginado;
  }

  restaurarPageState() {
    // filtros
    let localFiltros = JSON.parse(localStorage.getItem('ver_personas_filtros'));
    if (localFiltros != null) {
      this.filtros = localFiltros;
    } else {
      for (let propiedad in this.filtros) {
        this.filtros[propiedad] = '';
      }
    }
    // paginado
    let localPaginado = JSON.parse(localStorage.getItem('ver_personas_filtros'));
    if (localPaginado != null) {
      this.page = localPaginado;
    } else {
      this.page.pageIndex = 0;
      this.page.pageSize = +localStorage.getItem('ver_personas_paginado_size') || 20;
      this.page.length = 0;
    }
    // sort
    let localSort = JSON.parse(localStorage.getItem('ver_personas_sort'));
    if (localSort != null) {
      // para el sort tenemos que hacerlo con un "set" porque arregla un bug de "matSort"
      this.setActiveSortProgrammatically(localSort.active, localSort.direction);
    } else {
      this.setActiveSortProgrammatically('fechaModificacion', 'desc');
    }
    this.actualizarTabla();
  }

  /**
 * Para arreglar un bug de angular usamos esta funcion para ordenar
 */
  setActiveSortProgrammatically(active, direction): void {
    let interval = setInterval(() => {
      if (this.matSort) {
        clearInterval(interval);
        if (this.sort.active != active || this.sort.direction != direction) {
          this.sort = <MatSort>{
            active: active,
            direction: direction
          };
          this.matSort.sort({
            id: active,
            start: direction,
            disableClear: true
          });
          // ugly hack!
          const activeSortHeader = this.matSort.sortables.get(active);
          if (activeSortHeader) {
            activeSortHeader['_setAnimationTransitionState']({
              fromState: direction,
              toState: 'active'
            });
          }
        }
      }
    }, 0);
  }

  sortData(sort: Sort) {
    if(this.filterMode == 'default'){
    this.sort = sort;
    this.actualizarTabla();
    }
    else if(this.filterMode == 'home'){
      this.sort = sort;
      this.buscarFiltro();
    }else{
      this.sort = sort;
      this.actualizarTabla();
    }
  }

  onPage(pageEvent: PageEvent) {
    if(this.filterMode == 'default'){
    localStorage.setItem('ver_' + this.titulo + '_paginado_size', pageEvent.pageSize.toString());
    this.page = pageEvent;
    this.actualizarTabla();
    }
    else if(this.filterMode == 'home'){
      localStorage.setItem('ver_' + this.titulo + '_paginado_size', pageEvent.pageSize.toString());
      this.page = pageEvent;
      this.buscarFiltro();
    }
    else{
      localStorage.setItem('ver_' + this.titulo + '_paginado_size', pageEvent.pageSize.toString());
      this.page = pageEvent;
      this.actualizarTabla();
    }
  }

  onFiltro() {
    this.page.pageIndex = 0;
  }

  reiniciarPageState() {

    this._limpiarPageState();
    this.restaurarPageState();
  }

  actualizarTabla(): void {
    this.cargando = true;
    this.recordarPageState();
    this.checkPageState();
    this._personasSv.getPersonas(
      {
        page: this.page.pageIndex,
        pageSize: this.page.pageSize
      },
      {
        sort: this.sort.active,
        order: this.sort.direction
      },
      Object.assign(this.filtros)
    )
      .subscribe(
        respuesta => {
          this.cargando = false;
          const data = this._cmSv.format(respuesta, false);
          if (data != this._cmSv.SIN_DATA) {
            this.PersonasDataSource.data = data.entidades.map(entidades => {
              // this.traerContactos(entidades.id); // traer sus contactos
              return entidades
            });

            this.max_progreso = data.max_progreso;
            this.total = data.total;
            let i = 0;
            while (10 > i) {
              this.estados[i] = this.colorProgreso(i + 1, 1, 10);
              i++;
            }
          }
        },
        () => {
          this.cargando = false; // ocultar progress bar si se estaba mostrando
        },
        () => {
          this.cargando = false; // ocultar progress bar si se estaba mostrando
        }
      );
  }

  // traerContactos(IdEntidad: number): void {
  //   // console.log(this.entidad);
  //   if (IdEntidad) { // si hay un ID
  //     this.contactoService.getContactos(
  //       {
  //         page: null,
  //         pageSize: null
  //       },
  //       {
  //         sort: 'nombre',
  //         order: 'asc'
  //       },
  //       {
  //         IdEntidad: IdEntidad
  //       }
  //     ).subscribe(
  //       respuesta => {
  //         if (respuesta.estado == 1 && respuesta.data && respuesta.data.contactos) {
  //           if (respuesta.data.contactos.length > 0) {
  //             var contacto = respuesta.data.contactos[0];
  //             if (contacto.telefono != '' || contacto.celular != '') {
  //               // console.log(contacto);
  //               this.entidadContactos[IdEntidad] = new Contacto(
  //                 contacto.nombre,
  //                 contacto.email,
  //                 contacto.telefono,
  //                 contacto.celular,
  //                 <TipoContacto>{
  //                   IdTipoContacto: contacto.tipo.id,
  //                   tipoContactoDesc: contacto.tipo.desc
  //                 },
  //                 contacto.idContacto,
  //                 contacto.interno
  //               )
  //             } else {
  //               this.entidadContactos[IdEntidad] = new Contacto;
  //             }
  //           }
  //         }

  //       },
  //       () => {
  //       }
  //     );
  //   }
  // }

  colorProgreso(perc, min, max) {
    var base = (max - min);

    if (base == 0) {
      perc = 100;
    } else {
      perc = (perc - min) / base * 100;
    }
    var r, g, b = 0;

    if (perc < 50) {
      r = 255;
      g = Math.round(5.1 * perc);
    } else {
      g = 255;
      r = Math.round(510 - 5.10 * perc);
    }
    var h = r * 0x10000 + g * 0x100 + b * 0x1;
    return '#' + ('000000' + h.toString(16)).slice(-6);
  }

  colorFuente(perc, min, max) {
    var base = (max - min);
    if (base == 0) {
      perc = 100;
    } else {
      perc = (perc - min) / base * 100;
    }
    if (perc < 50) {
      return '#' + 'ffffff';
    } else {
      return '#' + '000000';
    }
  }

  descargarListado() {
    this.descargandolistado = true;
    this._personasSv.getPersonas(
      {
        page: null,
        pageSize: null
      },
      {
        sort: this.sort.active,
        order: this.sort.direction
      },
      Object.assign(this.filtros)
    ).subscribe((data: any) => {
      const blobData = new Blob([data['archivo']], { type: 'text/csv' });
      saveAs(blobData, 'clientes_listado.csv');
      this.descargandolistado = false;
    });
  }

  fallaDescargarListado() {
    this.snackBar.open('Lo sentimos, no se pudo descargar el listado', 'OK', { duration: 4750 });
  }

}
